<div class="login-container">
  <div class="login-card">
    <div class="home-navigation">
      <button mat-button routerLink="/" class="home-link">
        <mat-icon>chevron_left</mat-icon>
        Back to Home
      </button>
    </div>

    <div class="login-header">
      <h1>Welcome Back</h1>
      <p>Sign in to your AI Optima account</p>
    </div>

    <form [formGroup]="loginForm" (ngSubmit)="login()">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Email</mat-label>
        <input matInput formControlName="email" type="email" placeholder="Enter your email" />
        <mat-error *ngIf="loginForm.get('email')?.touched && loginForm.get('email')?.invalid">
          {{ getErrorMessage('email') }}
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Password</mat-label>
        <input matInput type="password" formControlName="password" placeholder="Enter your password" />
        <mat-error *ngIf="loginForm.get('password')?.touched && loginForm.get('password')?.invalid">
          {{ getErrorMessage('password') }}
        </mat-error>
      </mat-form-field>

      <div class="forgot-link">
        <a routerLink="/forgot-password">Forgot password?</a>
      </div>

      <button mat-raised-button color="primary" type="submit" class="full-width login-button"
        [disabled]="loginForm.invalid || isLoading">
        <mat-spinner diameter="20" *ngIf="isLoading"></mat-spinner>
        <span *ngIf="!isLoading">{{ isLoading ? 'Signing In...' : 'Sign In' }}</span>
      </button>
    </form>

    <div class="register-link">
      <p>Don't have an account? <a routerLink="/register">Create Account</a></p>
    </div>
  </div>
</div>
